import { useEffect } from "react";

import { useAppDispatch } from "store";
import { setPageTitle, T_PageTitle } from "store/pageTitleSlice";
import { PROJECT_INFO } from "utils/constants";

/**
 * To be imported in each page to change page name in both - document.title & layout header
 * @param title it denotes the document title that will will show on the tab name - project name will be appended after the passed `title`
 * @param pageTitle it will be shown as page name in the header. It supports breadcrumb behaviour if link is also mentioned in any object
 * @returns
 */
function PageTitle({ title, pageTitle }: { title: string; pageTitle: T_PageTitle }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.title = `${title} | ${PROJECT_INFO.name}`;
    dispatch(setPageTitle(pageTitle));
  }, [title, pageTitle]);

  return <></>;
}

export default PageTitle;
